export const white = 'rgba(255, 255, 255, 1)';
export const grey = 'rgba(199, 199, 199, 1)';
export const mediumGrey = 'rgba(112, 112, 112, 1)';
export const anthracite = 'rgba(34, 34, 34, 1)';

export const black = 'rgba(0, 0, 0, 1)';

export const lightGreen = 'rgba(0, 210, 164, 1)'; // #00d2a4
export const mediumGreen = 'rgba(2, 129, 102, 1)';

export const trustpilotGreen = '#00b67a';

export const yellow = 'rgba(255, 187, 0, 1)';
export const lightYellow = 'rgba(255, 204, 0, 0.15)';
export const orange = 'rgba(255, 143, 0, 1)';
export const lightOrange = 'rgba(255, 187, 0, 0.15)';
export const red = 'rgba(255, 95, 119, 1)';
